import React, {Fragment, Suspense, useEffect, useState} from 'react';
import { encode } from 'html-entities';
import Select from "react-select";
import { useForm, Controller } from "react-hook-form";
import CommonHeaderContent from '../../../Common/CommonHeaderContent';
import CratioLookup from '../../Common/CratioLookup';
import { HtmlDecode, HtmlEncode, loadListOptions, populateFormDetails } from '../../../Common/Appcommon';
import { useRef } from 'react';
import { faFloppyDisk } from '@fortawesome/free-regular-svg-icons';

function UpdateAction(props){
    let {onSelectChange, closeModal, screenDetail,systemActionSubmit, typeofaction, actions, actionIndex, enableActionDelay} = props;
    const [showLoader, setShowLoader] = useState(false);
    const [formData, setFormData] = useState({});
    const [selectedOwner, setOwnerValueSelected] = useState([]);
    const [selectedField, setSelectedField] = useState([]);
    const [ownerValue, setOwner] = useState([]);
    let [ownerField, setOwnerFieldDetail] = useState([]);
    let [fieldList, setFieldList] = useState([]);
    let [linkedFormList, setLinkedFormList] = useState([]);
    let [selectedForm, setSelectedForm] = useState([]);
    let [scr, setScreenDetails] = useState(screenDetail);
    let [selectedFD, setSelectedFD] = useState([]);
    let [comboboxSelected, setComboboxOption] = useState([]);
    const buttonClickRef = useRef();
    //let ownerField = [];
        
    useEffect(() => {
        
        
    }, []);

    useEffect(() => {
        constructFormFieldDetails(scr);
        (async () => {
            if(actions[actionIndex] !== undefined){
                let actionData = actions[actionIndex];
                await prepareActionEditor(actionData);
            }
        })();
        return () => {
          // this now gets called when the component unmounts
        };
        
    }, []);

    const prepareActionEditor = async (actionData) => {
        let actionName = actionData['action_name'];
        let formname = actionData['formname'];
        let systemActionStr = actionData['systemActionStr'];
        await parseExpressionStr(actionData['action_id'], actionName, systemActionStr);
    }

    const parseExpressionStr = async (actionId, actionName, systemActionStr) => {
        if(systemActionStr !== ""){
            formData['action_id'] = actionId;
            let arr = systemActionStr.split(".");
            if(systemActionStr.startsWith("$")){
                let valarr = systemActionStr.split("@");
                for(let i = 0; i < valarr.length; i++){
                    let text = valarr[i];
                    if(text.startsWith("$")){
                        continue;
                    } else {
                        arr = text.split(".");
                        break;
                    }
                }
            }
            //"$false@"+moduleName+"."+formname+"."+fieldName+"="+value+"@";
            let moduleName = arr[0];
            let formName = arr[1];
            let fieldInfo = arr[2].split("=");
            let fieldName = fieldInfo[0];
            let fieldValue = fieldInfo[1];
            if(fieldValue.startsWith("EXECUTE")){
                let farr = fieldValue.split(":");
                if(farr.length > 0){
                    fieldValue = farr[2];
                }
            }
            for(let li = 0; li < linkedFormList.length; li++){
                let form = linkedFormList[li];
                if(formName === form.value){
                    setSelectedForm(form);
                    break;
                }
            }
            let mappedField = [];
            for(let fi = 0; fi < fieldList.length; fi++){
                let field = fieldList[fi];
                if(fieldName === field.value){
                    setSelectedField(field);
                    mappedField = field;
                    setSelectedFD(field.fd);
                    break;
                }
            }
            if(Object.keys(mappedField).length > 0){
                let field = mappedField;
                let ftype = field.type;
                if(ftype === "entity_group"){
                    setOwner(fieldValue);
                } else if (ftype !== undefined && ftype.toLowerCase() === "combobox") {
                    let comboboxLists = loadListOptions(field.fd);
                    let selectedCombobox = [];
                    for(let ci = 0; ci < comboboxLists.length; ci++){
                        let list = comboboxLists[ci];
                        if(fieldValue === list.value){
                            selectedCombobox = list;
                            break;
                        }
                    }
                    setComboboxOption(selectedCombobox);
                }
                fieldValue = HtmlDecode(fieldValue);
                formData["own_value"] = fieldValue;
                formData['action_name'] = actionName;
                setFormData(formData);
            }
        }
    }

    const constructFormFieldDetails = (screenDetail, refreshLinkedForms = true) => {
        fieldList = [];
        let otherForms = [];
        let fieldDetails = screenDetail.length > 0 ? screenDetail[1] : [];
        let formDetail = screenDetail.length > 0 ? screenDetail[0]: [];
        let curFormname = "";
        let curFormlabel = "";
        if(formDetail.length > 0){
            curFormname = formDetail[1];
            curFormlabel = formDetail[2];
            otherForms.push({value: curFormname, label: curFormlabel});
            setSelectedForm({value: curFormname, label : curFormlabel});
        }
        let linkForms = {};
        for(let fi = 0; fi < fieldDetails.length; fi++){
            let fd = fieldDetails[fi];
            let formname = fd[1];
            let fieldName = fd[2];
            let fieldLabel = fd[3];
            let fieldType = fd[4];
            if(fieldType === "entity_group"){
                setOwnerFieldDetail(ownerField);
                //break;
            }
            let isMappingEnabled = parseInt(fd[31]);
            if(fieldType === "subtable" || !isMappingEnabled){
                continue;
            }
            if(fieldType === 'reference' || fieldType === 'reference_entityid' || fieldType === "reference_group" || fieldType === "form_history"){
                let refDetails = fd[35];
                let refModuleName = refDetails[0];
                if(refModuleName !== "Setup" && refModuleName !== "Documents" && refModuleName !== "History" && refModuleName !== "Calendar" && refModuleName !== "EmailSend"){
                    let refFormname = refDetails[1];
                    let refFormLabel = refDetails[10];
                    if(refFormLabel === undefined || refFormLabel === "" || linkForms[refFormname] !== undefined){
                        continue;
                    }
                    linkForms[refFormname] = refFormLabel;
                    otherForms.push({value: refFormname, label: refFormLabel});
                }
                continue;
            }
            if(fd[23] !== "1" && fieldName !== formname+"_id"){
                fieldList.push({value: fieldName, label: fieldLabel, type: fieldType, formname : formname, fd: fd});
            }
        }
        if(refreshLinkedForms){
            setLinkedFormList(otherForms);
        }
        setFieldList(fieldList);
    }

    const onInputChange = async(e) => {
        let name = e.target.name;
        let value = e.target.value;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
          }));
    }

    const onDropDownChange = async (selectedValue, objName) => {
        if(objName === "owner_field"){
            setOwnerValueSelected(selectedValue);
        } else if (objName === "field_selection"){
            setSelectedField(selectedValue);
            setSelectedFD(selectedValue.fd);
            if(selectedValue.type.toLowerCase() === "date" || selectedValue.type.toLowerCase() === "date_time"){
                formData["own_value"] = "";
                setFormData(formData);
            } else {
                formData["own_value"] = "";
                setFormData(formData);
            }
        }else if (objName === "form_name"){
            setSelectedForm(selectedValue);
            let formDetail = await populateFormDetails(selectedValue.value);
            setScreenDetails(formDetail);
            constructFormFieldDetails(formDetail, false);
        } else if (objName === "own_value"){
            formData["own_value"] = selectedValue.value;
            setFormData(formData);
            setComboboxOption(selectedValue);
        }
    }

    const onOwnerChange = async (e, selectedValue, objName) => {
        setOwner(selectedValue);
        formData["own_value"] = selectedValue.value;
        setFormData(formData);
    }

    const saveUpdateFieldAction = async() => {
        if(Object.keys(selectedField).length > 0){
            let fd = selectedField.fd;
            let value = formData.own_value;
            let moduleName = fd[0];
            let formname = fd[1];
            let fieldName = fd[2];
            let fieldType = fd[4];
            if(fieldType.toLowerCase() === "date" || fieldType.toLowerCase() === "date_time"){
                value = "EXECUTE:"+fieldType.toLowerCase()+":"+value;
            }
            value = HtmlEncode(value);
            let systemActionStr = "$false@"+moduleName+"."+formname+"."+fieldName+"="+value+"@";
            let updateActionParams = formData;
            updateActionParams['owner'] = ownerValue;
            updateActionParams['selectedField'] = selectedField;
            updateActionParams['selectedForm'] = selectedForm;
            updateActionParams['systemActionStr'] = systemActionStr;
            updateActionParams['typeofaction'] = typeofaction;
            systemActionSubmit(updateActionParams, actionIndex);
            enableActionDelay();
            closeModal();
        }
    }

    const triggerSubmit = () => {
        buttonClickRef.current.click();
    }

    const { register, handleSubmit : handleActionFormSubmit, control, formState: { errors },getValues } = useForm();
    return <Fragment>
                <CommonHeaderContent
                    isModal={true}
                    closeModal={closeModal}
                    headerTitle={"Update Field"}
                    buttonAction={triggerSubmit}
                    buttonTxt={"Save & Close"}
                    buttonIcon={faFloppyDisk}
                    isClassNeeded={false}
                    mainContent={
                        <Fragment>
                            <form id="action-form" name="task-action" onSubmit={handleActionFormSubmit(saveUpdateFieldAction)}>
                                <div className='action-editor-container'>
                                    <div className='editor-header'>
                                        <span className='headerSpan'></span>
                                    </div>
                                    <div className='editor-body'>
                                        <div className='form-conatiner'>
                                            <div className='input-section'>
                                                <label className={'workflow-lbl form-label'} htmlFor="action_name">Name</label>
                                                <Controller
                                                    name="action_name"
                                                    control={control}
                                                    rules={{ required: formData.action_name === undefined || formData.action_name === "" ? "Please provide name" : false }}
                                                    render={({ field }) => {
                                                        return (
                                                            <input
                                                                {...field}
                                                                type="text"
                                                                name="action_name"
                                                                id="task-name"
                                                                value={formData.action_name}
                                                                autoComplete={"off"}
                                                                onChange={(e) => {
                                                                    field.onChange(e);
                                                                    onInputChange(e);
                                                                }}
                                                                className={`form-control ${errors.action_name ? 'is-invalid' : ''}`}
                                                            />
                                                        );
                                                    }}
                                                />
                                                {errors.action_name && <em className={`error invalid-feedback`}>{errors.action_name.message}</em>}
                                            </div>
                                            <div className='input-section'>
                                                <label className={'workflow-lbl form-label'} htmlFor="form_name">Form</label>
                                                <Controller
                                                    name="form_name"
                                                    control={control}
                                                    rules={{ required: Object.keys(selectedForm).length === 0 ? "Please provide form name" : ""}}
                                                    render={({ field }) => {
                                                        return (
                                                            <Select
                                                                    {...field}
                                                                    placeholder={'---Choose One---'}
                                                                    menuPlacement={"auto"}
                                                                    menuPosition={'fixed'}
                                                                    name={"form_name"}
                                                                    id={"form_name"}
                                                                    className={`basic-multi-select ${errors.form_name ? 'is-invalid' : ''}`}
                                                                    classNamePrefix="wa-select"
                                                                    value={selectedForm}
                                                                    onChange={e => {
                                                                        onDropDownChange(e,"form_name");
                                                                        field.onChange(e);
                                                                    }}
                                                                    options={linkedFormList}
                                                            />
                                                        );
                                                    }}
                                                />
                                                {errors.form_name && <em className={`error invalid-feedback`}>{errors.form_name.message}</em>}
                                            </div>
                                            <div className='input-section '>
                                                <label className={'workflow-lbl form-label'} htmlFor="field_selection">Field</label>
                                                <div className={`${(Object.keys(selectedField).length > 0 && (selectedField.type.toLowerCase() !== "date" && selectedField.type.toLowerCase() !== "date_time"))  ? 'd-flex-alone' : ''}`}>
                                                <div className={`${(Object.keys(selectedField).length > 0 && (selectedField.type.toLowerCase() !== "date" && selectedField.type.toLowerCase() !== "date_time"))  ? 'col-md-6' : 'col-md-12'}`}>
                                                    <Controller
                                                        name="field_selection"
                                                        control={control}
                                                        rules={{ required: Object.keys(selectedField).length === 0 ? "Choose" : false }}
                                                        render={({ field }) => {
                                                            return (
                                                                <Select
                                                                    {...field}
                                                                    placeholder={'---Choose One---'}
                                                                    menuPlacement={"auto"}
                                                                    menuPosition={'fixed'}
                                                                    name={"field_selection"}
                                                                    id={"field_selection"}
                                                                    className={`basic-multi-select ${errors.field_selection ? 'is-invalid' : ''}`}
                                                                    classNamePrefix="wa-select"
                                                                    value={selectedField}
                                                                    onChange={e => {
                                                                        onDropDownChange(e,"field_selection");
                                                                        field.onChange(e);
                                                                    }}
                                                                    options={fieldList}
                                                                />
                                                            );
                                                        }}
                                                    />
                                                    {errors.field_selection && <em className={`error invalid-feedback`}>{errors.field_selection.message}</em>}
                                                    
                                                </div>
                                                {Object.keys(selectedField).length > 0 && selectedField.type === "entity_group" && 
                                                    <div className='col-md-6'>
                                                        <CratioLookup
                                                            customClass={"fc-field dIB Input referenceInput col-md-12"}
                                                            value={ownerValue}
                                                            refdetails={selectedFD[35]}
                                                            onChangeEvent={onOwnerChange}
                                                            valueProp={"label"}
                                                            attributes={{
                                                                "data-type": "value",
                                                                "data-key": "value_0",
                                                                "data-wgt": "lookup",
                                                            }}
                                                            controls={{ name: "referenceInput" }}
                                                        />
                                                    </div>
                                                }
                                                {Object.keys(selectedField).length > 0 && (selectedField.type.toLowerCase() === "text" || selectedField.type.toLowerCase() === "text area" || selectedField.type.toLowerCase() === "SuggestBox") && 
                                                    <div className='col-md-6'>
                                                        <Controller
                                                            name="own_value"
                                                            control={control}
                                                            rules={{ required: formData.own_value === undefined || formData.own_value === "" ? "Please provide valid value" : ""}}
                                                            render={({ field }) => {
                                                                return (
                                                                    <input
                                                                        {...field}
                                                                        type="text"
                                                                        name="own_value"
                                                                        id="own_value"
                                                                        value={formData.own_value}
                                                                        autoComplete={"off"}
                                                                        onChange={(e) => {
                                                                            onInputChange(e);
                                                                            field.onChange(e);
                                                                        }}
                                                                        className={`form-control update_value ${errors.own_value ? 'is-invalid' : ''}`}
                                                                    />
                                                                );
                                                            }}
                                                        />
                                                        {errors.own_value && <em className={`error invalid-feedback`}>{errors.own_value.message}</em>}
                                                    </div>
                                                }
                                                {Object.keys(selectedField).length > 0 && selectedField.type.toLowerCase() === "email" && 
                                                    <div className='col-md-6'>
                                                        <Controller
                                                            name="own_value"
                                                            control={control}
                                                            rules={{ required: formData.own_value === undefined || formData.own_value === "" ? "Please provide valid value" : ""}}
                                                            render={({ field }) => {
                                                                return (
                                                                    <input
                                                                        {...field}
                                                                        type="email"
                                                                        name="own_value"
                                                                        id="own_value"
                                                                        value={formData.own_value}
                                                                        autoComplete={"off"}
                                                                        onChange={(e) => {
                                                                            onInputChange(e);
                                                                            field.onChange(e);
                                                                        }}
                                                                        className={`form-control update_value ${errors.own_value ? 'is-invalid' : ''}`}
                                                                    />
                                                                );
                                                            }}
                                                        />
                                                        {errors.own_value && <em className={`error invalid-feedback`}>{errors.own_value.message}</em>}
                                                    </div>
                                                }
                                                {Object.keys(selectedField).length > 0 && selectedField.type.toLowerCase() === "mobileno" && 
                                                    <div className='col-md-6'>
                                                        <Controller
                                                            name="own_value"
                                                            control={control}
                                                            rules={{ required: formData.own_value === undefined || formData.own_value === "" ? "Please provide valid value" : ""}}
                                                            render={({ field }) => {
                                                                return (
                                                                    <input
                                                                        {...field}
                                                                        type="tel"
                                                                        name="own_value"
                                                                        id="own_value"
                                                                        value={formData.own_value}
                                                                        autoComplete={"off"}
                                                                        onChange={(e) => {
                                                                            onInputChange(e);
                                                                            field.onChange(e);
                                                                        }}
                                                                        className={`form-control update_value ${errors.own_value ? 'is-invalid' : ''}`}
                                                                    />
                                                                );
                                                            }}
                                                        />
                                                        {errors.own_value && <em className={`error invalid-feedback`}>{errors.own_value.message}</em>}
                                                    </div>
                                                }
                                                {Object.keys(selectedField).length > 0 && (selectedField.type.toLowerCase() === "int" || selectedField.type.toLowerCase() === "currency") && 
                                                    <div className='col-md-6'>
                                                        <Controller
                                                            name="own_value"
                                                            control={control}
                                                            rules={{ required: formData.own_value === undefined || formData.own_value === "" ? "Please provide valid value" : ""}}
                                                            render={({ field }) => {
                                                                return (
                                                                    <input
                                                                        {...field}
                                                                        type="number"
                                                                        name="own_value"
                                                                        id="own_value"
                                                                        value={formData.own_value}
                                                                        autoComplete={"off"}
                                                                        onChange={(e) => {
                                                                            onInputChange(e);
                                                                            field.onChange(e);
                                                                        }}
                                                                        className={`form-control update_value ${errors.own_value ? 'is-invalid' : ''}`}
                                                                    />
                                                                );
                                                            }}
                                                        />
                                                        {errors.own_value && <em className={`error invalid-feedback`}>{errors.own_value.message}</em>}
                                                    </div>
                                                }
                                                {Object.keys(selectedField).length > 0 && (selectedField.type.toLowerCase() === "date" || selectedField.type.toLowerCase() === "date_time") && 
                                                    <div className='col-md-12 mt-3'>
                                                    <div className='d-flex-alone align-center'>
                                                        <label className={'workflow-lbl mr-1'} >EXECUTION DAY/TIME +</label>
                                                        <div className='col-md-2'>
                                                        <Controller
                                                            name="own_value"
                                                            control={control}
                                                            rules={{ required: formData.own_value === undefined || formData.own_value === "" ? "Please provide valid value" : ""}}
                                                            render={({ field }) => {
                                                                return (
                                                                    <input
                                                                        {...field}
                                                                        type="text"
                                                                        name="own_value"
                                                                        id="own_value"
                                                                        value={formData.own_value}
                                                                        autoComplete={"off"}
                                                                        onChange={(e) => {
                                                                            onInputChange(e);
                                                                            field.onChange(e);
                                                                        }}
                                                                        className={`form-control update_value ${errors.own_value ? 'is-invalid' : ''}`}
                                                                    />
                                                                );
                                                            }}
                                                        />
                                                        
                                                        </div>
                                                        <label className={'workflow-lbl ml-1'} >days</label>
                                                        </div>
                                                        {errors.own_value && <em className={`error invalid-feedback`}>{errors.own_value.message}</em>}
                                                    </div>
                                                }
                                                {Object.keys(selectedField).length > 0 && (selectedField.type.toLowerCase() === "combobox") && 
                                                <div className='col-md-6'>
                                                    <Controller
                                                        name="own_value"
                                                        control={control}
                                                        rules={{ required: getValues("own_value") === undefined || getValues("own_value") === "" ? "Please provide valid value" : ""}}
                                                        render={({ field }) => {
                                                            return (
                                                                <Select
                                                                    {...field}
                                                                    placeholder={'---Choose One---'}
                                                                    menuPlacement={"auto"}
                                                                    menuPosition={'fixed'}
                                                                    name={"own_value"}
                                                                    id={"own_value"}
                                                                    className={`basic-multi-select ${errors.own_value ? 'is-invalid' : ''}`}
                                                                    classNamePrefix="wa-select"
                                                                    value={comboboxSelected}
                                                                    onChange={e => {
                                                                        onDropDownChange(e,"own_value");
                                                                        field.onChange(e);
                                                                    }}
                                                                    options={loadListOptions(selectedField.fd)}
                                                                />
                                                            );
                                                        }}
                                                    />
                                                    {errors.own_value && <em className={`error invalid-feedback`}>{errors.own_value.message}</em>}
                                                </div>
                                            }
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                    <div className='editor-footer modal-footer hide'>
                                        <a onClick={(e) => closeModal(e)} class="btn btn-outline-success">Cancel</a>
                                        <button ref={buttonClickRef} class="ml-1 btn btn-outline-success">Save</button>
                                    </div>
                                </div>
                            </form>
                        </Fragment>
                    } 
            />
        </Fragment>
}

export default UpdateAction;